/* eslint-disable camelcase */
import React from 'react';

import moment from 'moment';
import { useSettings } from 'src/services/sidebarSettings';

import { trackEvent } from 'src/lib/analytics';

import SummaryTable from 'src/views/components/SummaryTable';

import Actions from './Actions';
import Notes from './Notes';
import Timeline from './Timeline';

import './IncidentView.css';

const MAX_CHARS_IN_TITLE = 90;

const onClickPDLink = () => {
  trackEvent('sidebar_navigate_incident');
};

const Title = ({ title, html_url }) => {
  title = String(title);
  if (title.length > MAX_CHARS_IN_TITLE) {
    title = `${title.slice(0, MAX_CHARS_IN_TITLE - 3)}...`;
  }
  return <a href={html_url} onClick={() => onClickPDLink()} target="_blank" rel="noopener noreferrer">{title}</a>;
};

const Status = ({ status }) => (
  <tr>
    <td>Status:</td>
    <td><span className={`status ${status}`}>{status}</span></td>
  </tr>
);

const Urgency = ({ urgency }) => (
  <tr>
    <td>Urgency:</td>
    <td><span className={`urgency ${urgency}`}>{urgency}</span></td>
  </tr>
);

const IncidentNumber = ({ incident_number = null }) => incident_number && <tr>
  <td>Number:</td>
  <td>{incident_number}</td>
</tr>;

const Service = ({ service = null }) => service && <tr>
  <td>Service:</td>
  <td><a href={service.html_url} target="_blank" rel="noopener noreferrer"> {service.summary} </a></td>
</tr>;

const Ep = ({ escalation_policy = null }) => escalation_policy && <tr>
  <td>Escalation Policy:</td>
  <td><a href={escalation_policy.html_url} target="_blank" rel="noopener noreferrer"> {escalation_policy.summary} </a></td>
</tr>;

const Priority = ({ priority = null }) => priority && <tr>
  <td>Priority:</td>
  <td><span style={{}}>{priority.summary}</span></td>
</tr>;

const AssignedTo = ({ assignments = [] }) => (
  <tr>
    <td>Assignments:</td>
    <td>{ assignments.length
      ? assignments.map(({ assignee: a }) => <span key={a.id}> <a href={a.html_url} target="_blank" rel="noopener noreferrer">{a.summary}</a> </span>)
      : <span style={{ fontStyle: 'italic' }}>Not Assigned</span>
    }</td>
  </tr>
);

const PendingActions = ({ pending_actions }) => {
  if (!pending_actions || !pending_actions.length) return null;
  const pendingAction = pending_actions.sort((a, b) => (a.at > b.at ? 1 : -1))[0];

  if (typeof pendingAction.type !== 'string') return null;

  let does = `${pendingAction.type.charAt(0).toUpperCase()}${pendingAction.type.slice(1)}s`;

  if (pendingAction.type === 'urgency_change') {
    does = `Urgency changes to "${pendingAction.to}"`;
  }

  const pendingTime = moment(pendingAction.at).format('LT').replace(' ', '\u00A0');
  const fromNow = moment(pendingAction.at).fromNow();

  return (
    <tr>
      <td>Next Action:</td>
      <td>{ <span>{does} automatically at {pendingTime} ({fromNow})</span> }</td>
    </tr>
  );
};

const IncidentView = ({ incident, incidentAccountDomain }) => {
  const sidebarSettings = useSettings();
  return (
    <div className="incident-details">
      <div className="head">
        <div className="title">{sidebarSettings.title && <Title {...incident}/>}</div>
        <div className="actions"><Actions/></div>
      </div>
      <div>
        <SummaryTable>
          <tbody>
            {sidebarSettings.incidentNumber && <IncidentNumber {...incident}/>}
            {sidebarSettings.service && <Service {...incident}/>}
            {sidebarSettings.status && <Status {...incident}/>}
            {sidebarSettings.urgency && <Urgency {...incident}/>}
            {sidebarSettings.escalationPolicy && <Ep {...incident}/>}
            {sidebarSettings.priority && <Priority {...incident}/>}
            {sidebarSettings.assignments && <AssignedTo {...incident}/>}
            {sidebarSettings.pendingActions && <PendingActions {...incident}/>}
          </tbody>
        </SummaryTable>
        {sidebarSettings.showTimeline && <Timeline incident={incident} incidentAccountDomain={incidentAccountDomain}/>}
        {sidebarSettings.showNotes && <Notes incident={incident} incidentAccountDomain={incidentAccountDomain}/>}
      </div>
    </div>
  );
};

export default IncidentView;
